import { c as _c } from "react/compiler-runtime";
import { ProgressBarProps } from './progress-bar';
const ProgressBarFilled = t0 => {
  const $ = _c(13);
  const {
    progress
  } = t0;
  const t1 = `${progress}%`;
  let t2;
  if ($[0] !== t1) {
    t2 = {
      width: t1
    };
    $[0] = t1;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const t3 = `${100 * (100 / progress)}%`;
  let t4;
  if ($[2] !== t3) {
    t4 = {
      width: t3
    };
    $[2] = t3;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  let t5;
  if ($[4] !== progress || $[5] !== t4) {
    t5 = <div style={t4}>{progress}%</div>;
    $[4] = progress;
    $[5] = t4;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[7] !== t2 || $[8] !== t5) {
    t6 = <div className="text-background-secondary bg-text-primary absolute inset-0 h-full overflow-hidden rounded-xl" style={t2}>{t5}</div>;
    $[7] = t2;
    $[8] = t5;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  let t7;
  if ($[10] !== progress || $[11] !== t6) {
    t7 = <div className="text-text-primary bg-text-primary2 border-text-primary/30 relative h-[24px] w-full overflow-hidden rounded-xl border-[0.7px] text-center text-sm font-semibold leading-[22px]">{t6}{progress}%</div>;
    $[10] = progress;
    $[11] = t6;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  return t7;
};
export default ProgressBarFilled;